// The page a signed-out visitor tried to open (e.g. a shared scholarship link), so login can
// send them back to it. Kept in sessionStorage: it survives the Keycloak redirect in this tab only.
const KEY = "hec-return-path";

export const rememberReturnPath = (path) => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch (error) {
    console.warn("Could not remember the page to return to after login", error);
  }
};

// Returns the remembered in-app path once, then forgets it
export const takeReturnPath = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    // Only in-app paths, never another site
    return path?.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
};
